import { isFeatureEnabled } from 'owa-feature-flags';

// Cannot cache this value because user can enable/disable plugins
declare var ActiveXObject: any;

export default function isPDFPreviewSupported(
    userAgentString?: string,
    makeActiveXObject?: (name: string) => any,
    plugins?: any
): boolean {
    const ua =
        userAgentString ||
        (window && window.navigator && window.navigator.userAgent
            ? window.navigator.userAgent
            : '');
    const isBrowserIE =
        ua.indexOf('MSIE') !== -1 || // pre-IE11
        (ua.indexOf('rv:') !== -1 && ua.indexOf('Trident') !== -1); // IE11+
    const isBrowserChrome = ua.indexOf('Edge') === -1 && ua.indexOf('Chrome') !== -1;
    const isBrowserFirefox = ua.indexOf('Firefox') !== -1;
    const isBrowserEdge = ua.indexOf('Edge') !== -1;
    if (isBrowserChrome) {
        return hasChromePDFPlugin(plugins);
    } else if (isBrowserIE) {
        return hasAdobePlugin(makeActiveXObject || ((name: string) => new ActiveXObject(name)));
    } else if (isBrowserFirefox) {
        // use PDF.js instead if both pdfJsPreview and pdfJsPreviewDefaultInFirefox are available
        return !(
            isFeatureEnabled('doc-SxS-pdfJsPreview') &&
            isFeatureEnabled('doc-SxS-pdfJsPreviewDefaultInFirefox')
        );
    } else if (isBrowserEdge) {
        // use PDF.js instead if both pdfJsPreview and pdfJsPreviewDefaultInEdge are available
        return !(
            isFeatureEnabled('doc-SxS-pdfJsPreview') &&
            isFeatureEnabled('doc-SxS-pdfJsPreviewDefaultInEdge')
        );
    } else {
        return true;
    }
}

function hasAdobePlugin(makeActiveXObject: (name: string) => any): boolean {
    try {
        return makeActiveXObject('AcroPDF.PDF') !== null;
    } catch (e) {
        return false;
    }
}

function hasChromePDFPlugin(plugins?: any): boolean {
    plugins = plugins || (navigator && navigator.plugins);
    return plugins && plugins.namedItem('Chrome PDF Viewer') !== null;
}
